"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLocalStorage = exports.AppStorage = void 0;
exports.AppStorage = {
    getItem(key, defualtValue = null) {
        const data = window.sessionStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        }
        return defualtValue;
    },
    setItem(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    },
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    },
    clear() {
        window.sessionStorage.clear();
    },
};
exports.AppLocalStorage = {
    getItem(key, defualtValue = null) {
        const data = window.localStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        }
        return defualtValue;
    },
    setItem(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    },
    removeItem(key) {
        window.localStorage.removeItem(key);
    },
    clear() {
        window.localStorage.clear();
    },
};
